import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ParamsSet } from '../../models/server/params-set';
import { ConnectedUsersStateService } from '../state/connected-users-state.service';
import { ServiceBase } from './service-base';

@Injectable({
    providedIn: 'root',
})
export class ParamsService extends ServiceBase {
    /**
     * Constructeur
     */
    constructor(
        private http: HttpClient,
        public override connectedUserStateService: ConnectedUsersStateService
    ) {
        super(connectedUserStateService);
    }

    /**
     * Récupère le jeu de paramètres d'un utilisateur
     * @param userId Identifiant de l'utilisateur
     * @returns Retourne un jeu de paramètres
     */
    getForUser(userId: string): Observable<ParamsSet> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        };

        return this.http.get<ParamsSet>(this.baseUrl + `/api/organizations/${this.userConnected.organization.id}/paramssets?userId=${userId}`, httpOptions).pipe(map((x) => x));
    }
}
